import { cloneDeep } from '@apollo/client/utilities';
import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { HandlingUnit } from './handlingUnit';

export class HandlingUnitInput extends HandlingUnit implements EntityInput<HandlingUnit> {
  forCreate(): CreateHandlingUnitInput {
    return {
      ...this,
    };
  }

  forUpdate(): UpdateHandlingUnitInput {
    return {
      ...this,
    };
  }

  forDelete(): DeleteHandlingUnitInput {
    return DeleteHandlingUnitInput.from(this, DeleteHandlingUnitInput);
  }

  validate(): boolean {
    if (!this.productMasterDataId) return false;
    if (!this.parentId) return false;
    if (!this.quantity) return false;

    return true;
  }

  hasChanges(original: HandlingUnit | undefined): boolean {
    if (!original) return true;

    if (this.productMasterDataId !== original.productMasterDataId) return true;
    if (this.parentId !== original.parentId) return true;
    if (this.quantity !== original.quantity) return true;

    return false;
  }

  withProductMasterData(pmdId?: string) {
    (this as any).productMasterDataId = pmdId;
    (this as any).parentId = undefined;
    return cloneDeep(this);
  }

  withParent(parentId?: string) {
    (this as any).parentId = parentId;
    return cloneDeep(this);
  }

  withQuantity(quantity: number) {
    this.quantity = quantity;
    return cloneDeep(this);
  }

  withDefault(def: boolean) {
    this.default = def;
    return cloneDeep(this);
  }
}

export class CreateHandlingUnitInput extends forCreate(HandlingUnit) {}

export class UpdateHandlingUnitInput extends forUpdate(HandlingUnit) {}

export class DeleteHandlingUnitInput extends forDelete(HandlingUnit) {}
